import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker, ensurePushSubscription } from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker (PWA install + push handler).
// Push subscription is attempted on demand once the user is authenticated.
if (typeof window !== "undefined") {
  window.addEventListener("load", () => {
    registerServiceWorker().then((reg) => {
      if (!reg) return;
      // Try to subscribe shortly after auth state settles. If user isn't
      // logged in yet, the request will 401 and silently fail — we'll retry
      // on next page load.
      setTimeout(() => {
        ensurePushSubscription().catch(() => null);
      }, 4000);
    });
  });
}
